// Cómo terminó cada pedido del catálogo (sql/118) y las cuentas para las
// estadísticas de Pedidos. Funciones puras: se prueban sin base de datos.
import { etiquetaOrigen } from './origenCatalogo';

export const RESULTADOS = [
  { clave: 'compro', etiqueta: 'Compró', icono: '🛍️', color: '#047857', fondo: '#D1FAE5' },
  { clave: 'seguimiento', etiqueta: 'En seguimiento', icono: '⏳', color: '#B45309', fondo: '#FEF3C7' },
  { clave: 'no_compro', etiqueta: 'No compró', icono: '❌', color: '#B91C1C', fondo: '#FEE2E2' },
];

export const SIN_RESULTADO = { clave: null, etiqueta: 'Sin resultado', icono: '❔', color: '#6B7280', fondo: '#F3F4F6' };

export const MOTIVOS = [
  { clave: 'no_respondio', etiqueta: 'No respondió' },
  { clave: 'precio', etiqueta: 'Le pareció caro' },
  { clave: 'talla', etiqueta: 'No había su talla o color' },
  { clave: 'cambio_opinion', etiqueta: 'Ya no lo quiso' },
  { clave: 'envio', etiqueta: 'Por el envío o la entrega' },
  { clave: 'pago', etiqueta: 'Por la forma de pago' },
  { clave: 'otro', etiqueta: 'Otro motivo' },
];

export const infoResultado = (clave) => RESULTADOS.find((r) => r.clave === clave) || SIN_RESULTADO;
export const etiquetaMotivo = (clave) => MOTIVOS.find((m) => m.clave === clave)?.etiqueta || clave || '';

const totalPedido = (p) => (p.total ?? (p.precio || 0) * (p.cantidad || 1)) + (Number(p.envio) || 0);

// Mensaje para retomar a una clienta que no compró o quedó pendiente.
export function mensajeSeguimiento(p, { negocioNombre = '', enlaceCatalogo = '' } = {}) {
  const prendas = (p.prendas || [p]).map((x) => x.nombre_producto).filter(Boolean);
  const que = prendas.length > 1 ? `las piezas que te gustaron (${prendas.join(', ')})` : `la pieza que te gustó (${prendas[0] || 'tu pedido'})`;
  const tienda = negocioNombre ? ` de ${negocioNombre}` : '';
  return `¡Hola ${p.cliente_nombre}! 😊 Te escribo${tienda} por ${que}. ¿Te puedo ayudar con algo para que te la lleves? 💕`
    + (enlaceCatalogo ? `\n\nTambién tenemos piezas nuevas que te pueden encantar:\n${enlaceCatalogo}` : '');
}

// Inicio del período elegido en Estadísticas.
export function desdePeriodo(periodo, hoy = new Date()) {
  const d = new Date(hoy);
  if (periodo === 'mes') return new Date(d.getFullYear(), d.getMonth(), 1);
  if (periodo === 'mes_pasado') return new Date(d.getFullYear(), d.getMonth() - 1, 1);
  if (periodo === '30') { d.setDate(d.getDate() - 30); return d; }
  if (periodo === '90') { d.setDate(d.getDate() - 90); return d; }
  return null; // todo
}
export function hastaPeriodo(periodo, hoy = new Date()) {
  if (periodo === 'mes_pasado') return new Date(hoy.getFullYear(), hoy.getMonth(), 1);
  return null;
}

// Cuentas de las estadísticas sobre pedidos YA agrupados (un carrito = un pedido).
export function calcularEstadisticas(pedidos) {
  const est = {
    recibidos: pedidos.length, pendientes: 0, compro: 0, seguimiento: 0, no_compro: 0, sinResultado: 0,
    montoPedido: 0, montoComprado: 0, porOrigen: [], motivos: [], minutosAtencion: null,
  };
  const origenes = new Map();
  const motivos = new Map();
  const tiempos = [];
  pedidos.forEach((p) => {
    const monto = totalPedido(p);
    est.montoPedido += monto;
    if (p.estado === 'pendiente') est.pendientes += 1;
    else if (p.resultado === 'compro') { est.compro += 1; est.montoComprado += monto; }
    else if (p.resultado === 'seguimiento') est.seguimiento += 1;
    else if (p.resultado === 'no_compro') {
      est.no_compro += 1;
      const m = p.motivo || 'otro';
      motivos.set(m, (motivos.get(m) || 0) + 1);
    } else est.sinResultado += 1;

    const k = p.origen || '';
    const o = origenes.get(k) || { origen: p.origen || null, ...etiquetaOrigen(p.origen), pedidos: 0, compro: 0, monto: 0 };
    o.pedidos += 1;
    if (p.resultado === 'compro') { o.compro += 1; o.monto += monto; }
    origenes.set(k, o);

    if (p.estado !== 'pendiente' && p.atendido_en) {
      const min = (new Date(p.atendido_en) - new Date(p.creado_en)) / 60000;
      if (min > 0.05) tiempos.push(min); // los viejos sin hora real (atendido = creado) no cuentan
    }
  });
  est.conversion = est.recibidos ? Math.round((est.compro / est.recibidos) * 100) : 0;
  est.porOrigen = [...origenes.values()]
    .map((o) => ({ ...o, conversion: o.pedidos ? Math.round((o.compro / o.pedidos) * 100) : 0 }))
    .sort((a, b) => b.pedidos - a.pedidos || b.compro - a.compro);
  est.motivos = [...motivos.entries()].map(([clave, n]) => ({ clave, etiqueta: etiquetaMotivo(clave), n }))
    .sort((a, b) => b.n - a.n);
  if (tiempos.length) {
    const orden = [...tiempos].sort((a, b) => a - b);
    est.minutosAtencion = orden[Math.floor(orden.length / 2)]; // mediana: no la arrastra un pedido olvidado
  }
  return est;
}

// Pedidos por semana (lunes a domingo) de las últimas N semanas.
export function pedidosPorSemana(pedidos, semanas = 8, hoy = new Date()) {
  const lunes = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
  lunes.setDate(lunes.getDate() - ((lunes.getDay() + 6) % 7));
  const filas = [];
  for (let i = semanas - 1; i >= 0; i -= 1) {
    const desde = new Date(lunes); desde.setDate(desde.getDate() - 7 * i);
    const hasta = new Date(desde); hasta.setDate(hasta.getDate() + 7);
    filas.push({ desde, hasta, pedidos: 0, compro: 0, actual: i === 0 });
  }
  pedidos.forEach((p) => {
    const f = new Date(p.creado_en);
    const s = filas.find((x) => f >= x.desde && f < x.hasta);
    if (!s) return;
    s.pedidos += 1;
    if (p.resultado === 'compro') s.compro += 1;
  });
  return filas;
}

export function textoTiempo(min) {
  if (min == null) return '—';
  if (min < 60) return `${Math.max(1, Math.round(min))} min`;
  if (min < 60 * 24) return `${Math.round(min / 60)} h`;
  return `${Math.round(min / 1440)} día(s)`;
}
